// components/ui/ProgressBar.tsx
import { cn } from '../../lib/utils';

interface ProgressBarProps {
  value?: number; // 0-100, undefined for indeterminate
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'success' | 'warning' | 'error';
  showValue?: boolean;
  className?: string;
}

const sizeStyles = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
};

const colorStyles = {
  primary: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
};

export function ProgressBar({
  value,
  size = 'md',
  color = 'primary',
  showValue = false,
  className
}: ProgressBarProps) {
  const isIndeterminate = value === undefined;

  return (
    <div className={cn('w-full', className)}>
      <div className={cn('w-full bg-border rounded-full overflow-hidden', sizeStyles[size])}>
        {isIndeterminate ? (
          <div
            className={cn(
              'h-full rounded-full animate-progress-indeterminate',
              colorStyles[color]
            )}
            style={{ width: '40%' }}
          />
        ) : (
          <div
            className={cn(
              'h-full rounded-full transition-all duration-normal',
              colorStyles[color]
            )}
            style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
          />
        )}
      </div>
      {showValue && value !== undefined && (
        <span className="text-body-sm text-text-secondary mt-1">{Math.round(value)}%</span>
      )}
    </div>
  );
}
